<template>
  <span>
    <b-button variant="info" size="sm" class="mr-2 mb-2" v-b-toggle.sidebar-1>
      <em class="fa fa-info-circle"></em>
    </b-button>
    <b-sidebar id="sidebar-1" title="Search Criteria" shadow right>
      <div class="px-3 py-2">
        <p class="font-weight-bold text-info">
          Search Criteria apply to:
        </p>
        <ul>
          <li>Free Text Search</li>
          <li>Advanced Search</li>
        </ul>
        <p class="font-weight-bold text-info">
          Equal To:
        </p>
        <ul>
          <li>name=john</li>
          <li>name!=john</li>
        </ul>
        <p class="font-weight-bold text-info">
          Range Search:
        </p>
        <ul>
          <li>value(int)>20</li>
          <li>value(int)&lt;20</li>
          <li>value(int)>=20</li>
          <li>value(int)&lt;=20</li>
        </ul>
        <p class="font-weight-bold text-info">
          Like Search:
        </p>
        <ul>
          <li>name'like'john</li>
          <li>name'not like'john</li>
        </ul>
        <p class="font-weight-bold text-info">
          Array Search:
        </p>
        <ul>
          <li>status'in'SUCCESS</li>
          <li>status'not in'FAIL</li>
        </ul>
        <p class="font-weight-bold text-info">
          To match with atleast one value on non-array field:
        </p>
        <ul>
          <li>name'in'john[]doe</li>
        </ul>
        <p class="font-weight-bold text-info">
          To match with atleast one value on array field:
        </p>
        <ul>
          <li>name'in'john||doe</li>
        </ul>
        <p class="font-weight-bold text-info">
          To search with wildcard (val1 is an array of documents):
        </p>
        <ul>
          <li>attributes.contacts[*].status'in'draft||approved</li>
        </ul>
      </div>
    </b-sidebar>
  </span>
</template>
<script>
export default {
  props: {
    value: Boolean,
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
};
</script>
